import { Controller } from "@hotwired/stimulus"

import Stimulus from "../utils/stimulus"

class Theme extends Controller {
  connect() {
    const mq = window.matchMedia(`(prefers-color-scheme: dark)`)
    this.#apply(mq.matches)
    mq.addEventListener(`change`, (e) => this.#apply(e.matches))
  }

  #apply = (isDark) => {
    document.documentElement.classList.toggle(`dark-mode`, isDark)
  }
}

Stimulus.register(`theme`, Theme)
